import _extends from 'babel-runtime/helpers/extends';

/* eslint-disable max-lines */
import { mapGetters } from 'vuex';
import store from '@/store';
import { getTagList } from '@/api/common/index.js';
import { searchUserList } from '@/api/system/user';
import { fetchDemoCategory } from '@/api/manage';

export default {
  props: {
    fnSearch: {
      type: Function,
      default: false
    },
    prop: {
      type: Object,
      default: false
    }
  },
  computed: _extends({}, mapGetters(['category', 'material_options', 'user_id', 'languages']), {
    searchFieldPlaceholder: {
      get: function get() {
        var self = this;
        if (self.prop.searchField.length) {
          return self.prop.searchField.find(function (e) {
            return e.id === self.data.searchField;
          }).name;
        }
        return '关键词';
      }
    }
  }),
  data: function data() {
    return {
      options: {
        demoCid: [],
        tmpltype: [{
          id: '3',
          name: 'panoramic'
        }, {
          id: '2',
          name: 'playable'
        }, {
          id: '1',
          name: 'endcard'
        }],
        managerName: [],
        modelStyle: [],
        modelAnimation: [],
        platform: [{
          id: 'ios',
          name: 'iOS'
        }, {
          id: 'android',
          name: 'Android'
        }],
        picker: {
          shortcuts: [{
            text: this.$t('form.pastWeek'),
            onClick: function onClick(picker) {
              var end = new Date();
              var start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: this.$t('form.pastMonth'),
            onClick: function onClick(picker) {
              var end = new Date();
              var start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: this.$t('form.past3Month'),
            onClick: function onClick(picker) {
              var end = new Date();
              var start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        priority: [{
          id: '4',
          name: '紧急'
        }, {
          id: '3',
          name: '高'
        }, {
          id: '2',
          name: '中'
        }, {
          id: '1',
          name: '低'
        }],
        bugState: [{
          id: '1',
          name: '待解决'
        }, {
          id: '2',
          name: '已确认'
        }, {
          id: '3',
          name: '研发驳回'
        }, {
          id: '5',
          name: '测试驳回'
        }, {
          id: '4',
          name: '待验证'
        }, {
          id: '6',
          name: '已解决'
        }],
        qaStatus: [{
          id: '8',
          name: '自测'
        }, {
          id: '7',
          name: '待测试'
        }, {
          id: '1',
          name: '测试中'
        }, {
          id: '2',
          name: '测试通过'
        }, {
          id: '3',
          name: '待重测'
        }, {
          id: '9',
          name: '已发布'
        }],
        trafficType: [{
          id: '1',
          name: 'M流量'
        }, {
          id: '2',
          name: 'DSP流量'
        }],
        level: [{
          id: 'DEBUG',
          name: 'DEBUG'
        }, {
          id: 'WARN',
          name: 'WARN'
        }, {
          id: 'INFO',
          name: 'INFO'
        }, {
          id: 'ERROR',
          name: 'ERROR'
        }, {
          id: 'FATAL',
          name: 'FATAL'
        }]
      },
      data: {
        demoCid: '',
        tmpltype: '',
        managerName: '',
        modelStyle: '',
        modelAnimation: '',
        platform: '',
        networks: '',
        categories: '',
        materialTypes: '',
        tags: '',
        category: '',
        time: [],
        priority: '',
        bugState: '',
        qaStatus: '',
        trafficType: '',
        level: '',
        searchField: this.prop.defaultKey ? this.prop.defaultKey : 'app_name',
        keyword: '',
        language: ''
      },
      loading: {
        demoCid: true,
        modelStyle: true,
        modelAnimation: true,
        material: true,
        category: true,
        language: true
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    var self = this;
    if (self.prop.managerName) {
      searchUserList({
        page: 1,
        page_size: 400
      }).then(function (res) {
        var aTemp = [{ id: '0', nickname: 'All' }];
        self.options.managerName = aTemp.concat(res.data.data);
        self.data.managerName = self.options.managerName.find(function (e) {
          return Number(e.id) === Number(self.user_id);
        }).nickname;
        self.fnFilter();
      }).catch(function () {
        self.options.managerName = [];
      });
    }
    if (self.prop.modelStyle) {
      getTagList({
        type: 3
      }).then(function (res) {
        self.loading.modelStyle = false;
        self.options.modelStyle = res.data.data.tags;
      }).catch(function () {
        self.loading.modelStyle = false;
      });
    }
    if (self.prop.modelAnimation) {
      getTagList({
        type: 2
      }).then(function (res) {
        self.loading.modelAnimation = false;
        self.options.modelAnimation = res.data.data.tags;
      }).catch(function () {
        self.loading.modelAnimation = false;
      });
    }
    if (self.prop.materialOptions && !self.options.networks.length) {
      store.dispatch('GetMaterialOptions').then(function (res) {
        self.loading.material = false;
      }).catch(function () {
        self.loading.material = false;
      });
    } else {
      self.loading.material = false;
    }
    if (self.prop.category && !self.category.length) {
      store.dispatch('GetCategory').then(function (res) {
        self.loading.category = false;
      }).catch(function () {
        self.loading.category = false;
      });
    } else {
      self.loading.category = false;
    }
    if (self.prop.language) {
      store.dispatch('config/getLanguagesList').then(function (res) {
        self.loading.language = false;
      }).catch(function () {
        self.loading.language = false;
      });
    } else {
      self.loading.language = false;
    }
    if (self.prop.demoCid) {
      fetchDemoCategory().then(function (res) {
        _this.loading.demoCid = false;
        _this.options.demoCid = res.data.data.categories;
      }).catch(function () {
        _this.loading.demoCid = false;
      });
    }
    if (self.$route.query.search_key) {
      self.data.searchField = self.$route.query.search_key;
      self.data.keyword = self.$route.query.search_value;
      self.fnFilter();
    }
  },

  methods: {
    fnFilter: function fnFilter() {
      if (this.fnSearch) {
        var oData = {};
        for (var i in this.prop) {
          switch (i) {
            case 'demoCid':
              oData.cid = this.data[i];
              break;
            case 'tmplType':
              oData.category = this.data[i];
              break;
            case 'managerName':
              oData.manager_name = this.data[i] === 'All' ? '' : this.data[i];
              break;
            case 'material':
              oData.network = this.data.networks;
              oData.category = this.data.categories;
              oData.material_type = this.data.materialTypes;
              oData.tag_id = this.data.tags;
              break;
            case 'time':
              if (this.data.time) {
                oData.start_date = this.data.time[0];
                oData.end_date = this.data.time[1];
              }
              break;
            case 'searchField':
              oData.search_field = this.data.searchField;
              break;
            case 'bugState':
              oData.status = this.data.bugState;
              break;
            case 'qaStatus':
              oData.status = this.data.qaStatus;
              break;
            case 'modelStyle':
              oData.style_id = this.data.modelStyle;
              break;
            case 'modelAnimation':
              oData.type_id = this.data.modelAnimation;
              break;
            case 'trafficType':
              oData.traffic_type = this.data.trafficType;
              break;
            default:
              oData[i] = this.data[i];
              break;
          }
        }
        this.fnSearch(oData);
      }
    },
    fnReset: function fnReset() {
      var self = this;
      for (var i in this.data) {
        switch (i) {
          case 'searchField':
            this.data.searchField = this.prop.defaultKey ? this.prop.defaultKey : 'app_name';
            break;
          case 'managerName':
            if (this.options.managerName.length) {
              this.data.managerName = this.options.managerName.find(function (e) {
                return Number(e.id) === Number(self.user_id);
              }).nickname;
            } else {
              this.data.managerName = '';
            }
            break;
          default:
            this.data[i] = '';
            break;
        }
      }
      this.fnFilter();
    }
  }
};